import React from "react";
import AuthRoutes from "./Routes/authRoutes";
import AdminRoutes from "./Routes/adminRoutes";
import PermissionRoutes from "./Routes/permissionRoutes";
import CategoriesRoutes from "./Routes/categoriesRoutes";
import CategoriesResaleRoutes from "./Routes/categoriesResaleRoutes";
import CountryRoutes from "./Routes/countryRoutes";
import StateRoutes from "./Routes/stateRoutes";
import AgentRoutes from "./Routes/agentRoutes";
import PartnerRolesRoutes from "./Routes/partnerRolesRoute";
import ResellerRoutes from "./Routes/resellerRoute";
import HomeVisitRoutes from "./Routes/homeVisitRoutes";
import AgentProfitRangesRoutes from "./Routes/agentProfitRangeRoute";
import AccessListRoutes from "./Routes/accessListRoute";
import CityRoutes from "./Routes/cityRoutes";
import CollectionRoutes from "./Routes/collectionsRoutes";
import CollectionResaleRoutes from "./Routes/collectionsResaleRoutes";
import UnitsRoutes from "./Routes/unitsRoutes";
import AmenitiesRoutes from "./Routes/amenitiesRoutes";
import AmenitiesResaleRoutes from "./Routes/amenitiesResaleRoutes";
import BuilderRoutes from "./Routes/builderRoutes";
import BuilderResaleRoutes from "./Routes/builderResaleRoute";
import KioskRoutes from "./Routes/kiosk.Routes";
import ManageProjectsRoutes from "./Routes/manageProjectsRoutes";
import ProjectResaleRoutes from "./Routes/projectResaleRoute";
import TeamRoutes from "./Routes/teamRoutes";
import PropertiesRoutes from "./Routes/propertiesRoutes";
import PropertiesResaleRoutes from "./Routes/propertiesResaleRoute";
import PropertyResaleVibeRoutes from "./Routes/propertyResaleVibeRoutes";
import CouponsRoutes from "./Routes/couponsRoutes";
import MeetingRoutes from "./Routes/meetingRoutes";
import EventRoutes from "./Routes/eventsRoutes";
import SettingsRoutes from "./Routes/settingsRoutes";
import ListUsers from "./Routes/usersRoutes";
import EmailAddRoutes from "./Routes/emailAddRoutes";
import BookingRoutes from "./Routes/bookingsRoutes";
import BlogRoutes from "./Routes/blogRoute";
import VrShootRequestRoutes from "./Routes/vrShootRequestRoute";
import PaymentRoutes from "./Routes/paymentsRoutes";
import ConfigRoutes from "./Routes/configRoutes";
import BannerAdsRoutes from "./Routes/banner_adsRoutes";
import ChatRoutes from "./Routes/chatRoutes";
import DealsRoutes from "./Routes/dealsRoutes";
import WalletRefundRoutes from "./Routes/walletRefundRoutes";
import NewsRoutes from "./Routes/newsRoutes";
import NewsBrandRoutes from "./Routes/newsBrandRoutes";
import BrandsRoutes from "./Routes/brandsRoutes";
import BrandsLeasingRoutes from "./Routes/brandsLeasingRoute";
import SurroundingRoutes from "./Routes/surrounding-indutries";
import DashBoardRoutes from "./Routes/dashboardRoutes";
import LeadRoutes from "./Routes/leadRoutes";
import LogsRoutes from "./Routes/logsRoutes";
import InvitesRoutes from "./Routes/invitesRoutes";
import EnquiryRoutes from "./Routes/enquiryRoutes";
import CabSettingRoutes from "./Routes/cabSettingRoutes";
import ConsultantRoutes from "./Routes/consultantRoutes";
import CancellationPoliciesRoutes from "./Routes/cancellationRoutes";
import CurrencyRoutes from "./Routes/currencyRoutes";
import PlanRoutes from "./Routes/planRoutes";
import NotificationRoutes from "./Routes/notificationRoutes";
import EmailRoutes from "./Routes/emailTemplatesRoutes";
import ChangePasswordRoutes from "./Routes/ChangePasswordRoutes";
import FaqRoutes from "./Routes/FaqRoutes";
import DealsAndOfferRoutes from "./Routes/DealsAndOffersRoutes";
import CabServiceProviderRoutes from "./Routes/CabServiceProviderRoutes";
import SiteVisitRoutes from "./Routes/siteVisitRoutes";
import ReferralsRoutes from "./Routes/referralsRoutes"
import RewardsRoutes from "./Routes/rewardsRoutes"
import LocalityRoutes from "./Routes/localityRoutes"
import ReferralCommissionRoutes from "./Routes/referralCommissionRoutes"
// import FranchiseRoutes from "./Routes/franchiseRoutes"
import RankingRoutes from "./Routes/rankingRoutes"
import RankingResaleRoutes from "./Routes/resaleRankingRoutes"
import OoraPlanRoutes from "./Routes/ooraRoute"
import FeaturedBusinessPropertyRoutes from "./Routes/featuredBusinessPropertyRoute"
import ProjectReportRoutes from "./Routes/projectReportRoute"
import RentalPlanRoutes from "./Routes/rentalPlanRoute"
import HomeCategoryRoutes from "./Routes/homeCategoryRoute"
import HomeBannerRoutes from "./Routes/homeBannerRoute"
import HomeVRRoutes from "./Routes/homeVrRoutes"
import ContactUsRoutes from "./Routes/contactUs.route"
import ReelRankingRoutes from "./Routes/reelRankingRoutes"
import FinancePartnersRoutes from "./Routes/financePartnersRoutes"
import RatingReviewPanelSection from "./Routes/ratingReviewPanelRoutes"
import ComingSoonCitiesRoutes from "./Routes/comingSoonCitiesRoute"
import AppointmentConfigRoutes from "./Routes/appointmentConfigRoute"
import ExperienceCenterRoutes from "./Routes/experienceCenterRoute"
import RewardCouponRoutes from "./Routes/rewardCouponRoute"
import VrVisitLeadRoutes from "./Routes/leadRoute"
import AgentMarginDetailsRoutes from "./Routes/agentMarginDetailsRoutes"
import PropertiesRentalRoutes from "./Routes/rentalPropertiesRoutes"
import CorporateRentalDiscountRoutes from "./Routes/CorporateRentalDiscountRoutes"
import RentalBookingRoutes from "./Routes/rentalBookingRoutes"
import UserQueryProjectRoutes from "./Routes/userQueryProjectRoutes"
import UserViewVrHistoryRoutes from "./Routes/userViewVrHistoryRoutes"
import FranchiseManagerRoutes from "./Routes/franchiseManagerRoutes"

const Router = () => {
  return (
    <div>
      <AuthRoutes />
      <ChatRoutes />
      <MeetingRoutes />
      <BookingRoutes />
      <BlogRoutes />
      <KioskRoutes />
      <AdminRoutes />
      <PermissionRoutes />
      <CategoriesRoutes />
      <CategoriesResaleRoutes />
      <LeadRoutes></LeadRoutes>
      <CountryRoutes />
      <LogsRoutes></LogsRoutes>
      <StateRoutes />
      <AgentRoutes />
      <PartnerRolesRoutes />
      <ResellerRoutes />
      <RatingReviewPanelSection />
      <HomeVisitRoutes />
      <AgentProfitRangesRoutes />
      <CityRoutes />
      <AccessListRoutes ></AccessListRoutes>
      <CurrencyRoutes />
      <CollectionRoutes />
      <CollectionResaleRoutes />
      <UnitsRoutes />
      <BrandsLeasingRoutes />
      <RankingRoutes />
      <RankingResaleRoutes />
      <ComingSoonCitiesRoutes />
      <AmenitiesRoutes />
      <AmenitiesResaleRoutes />
      <OoraPlanRoutes />
      <RentalPlanRoutes />
      <PropertiesResaleRoutes />
      <AppointmentConfigRoutes />
      <BuilderRoutes />
      <BuilderResaleRoutes />
      <ManageProjectsRoutes />
      <ProjectResaleRoutes />
      <TeamRoutes />
      <VrShootRequestRoutes />
      <PropertiesRoutes />
      <PropertyResaleVibeRoutes />
      <CouponsRoutes />
      <EventRoutes />
      <ProjectReportRoutes />
      <SettingsRoutes />
      <ListUsers />
      <LocalityRoutes />
      <PaymentRoutes />
      <ConfigRoutes />
      <ContactUsRoutes />
      <HomeCategoryRoutes />
      <EmailAddRoutes></EmailAddRoutes>
      <BannerAdsRoutes />
      <HomeVRRoutes />
      <DealsRoutes />
      <PlanRoutes />
      <AgentMarginDetailsRoutes />
      <VrVisitLeadRoutes />
      <FeaturedBusinessPropertyRoutes />
      <ReelRankingRoutes />
      <HomeBannerRoutes />
      <SiteVisitRoutes />
      <ConsultantRoutes />
      <WalletRefundRoutes />
      <NewsRoutes></NewsRoutes>
      <NewsBrandRoutes></NewsBrandRoutes>
      <BrandsRoutes></BrandsRoutes>
      <SurroundingRoutes></SurroundingRoutes>
      <DashBoardRoutes></DashBoardRoutes>
      <InvitesRoutes></InvitesRoutes>
      <EnquiryRoutes></EnquiryRoutes>
      <CabSettingRoutes></CabSettingRoutes>
      <NotificationRoutes></NotificationRoutes>
      <EmailRoutes></EmailRoutes>
      <CancellationPoliciesRoutes></CancellationPoliciesRoutes>
      <ChangePasswordRoutes></ChangePasswordRoutes>
      <FaqRoutes></FaqRoutes>
      <DealsAndOfferRoutes></DealsAndOfferRoutes>
      <ReferralsRoutes></ReferralsRoutes>
      <RewardsRoutes></RewardsRoutes>
      <ReferralCommissionRoutes></ReferralCommissionRoutes>
      {/* <FranchiseRoutes></FranchiseRoutes> */}
      <FinancePartnersRoutes></FinancePartnersRoutes>
      <CabServiceProviderRoutes />
      <ExperienceCenterRoutes />
      <RewardCouponRoutes />
      <PropertiesRentalRoutes />
      <CorporateRentalDiscountRoutes />
      <RentalBookingRoutes />
      <UserQueryProjectRoutes />
      <UserViewVrHistoryRoutes />
      <FranchiseManagerRoutes />
    </div>
  );
};

export default Router;
